import React from "react";
import { FunctionDeleteConfirmationModalProps } from "../Interfaces/Interface";
const FunctionDeleteConfirmationModal: React.FC<FunctionDeleteConfirmationModalProps> = ({ isOpen, onClose, onConfirm, }) => {
  if (!isOpen) return null;
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Confirm Deletion</h3>
        <p>Are you sure you want to delete this checklist?</p>
        <div className="buttons">
          <button className="cancelbutton" onClick={onClose}>Cancel</button>
          <button className="savebutton" onClick={onConfirm}>Delete</button>
        </div>
      </div>
    </div>
  );
};
export default FunctionDeleteConfirmationModal;